<template>
  <div>
    <Header/>
    <Scroll/>
    <div>
      <div class="mall_pageTopWrap">
        <p class="mall_pageTopTit">Styling</p>
      </div>
      <div class="mall_arrC_Box mall_arrC_BoxPage">
        <div
          class="mall_arrC_contBox"
          v-for="item in statusData.StylingData"
          :key="item.styling_ID"
        >
          <router-link :to="{name: 'StylingDetail', query: {styling_ID: item.styling_ID}}">
            <p class="mall_arrC_img">
              <img
                :src="item.styling_main_image"
                :alt="item.styling_title"
              />
            </p>
            <div class="mall_arrC_txtBox">
              <p class="mall_arrC_txtBox_tit">{{item.styling_title}}</p>
              <p>{{item.styling_sub_title}}</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import {
  get_styling_use
} from '../../ETC/Axios.vue'

export default {
  name: 'Styling',
  components: {
    Header: Header,
    Footer: Footer,
    Scroll: Scroll
  },
  setup () {
    return {
      statusData: ref({
        StylingData: []
      })
    }
  },
  mounted () {
    get_styling_use().then(result_data => {
      this.statusData.StylingData = result_data
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Styling/Styling.vue